import React, { useEffect, useRef, useState } from 'react'
import Onboarding from './onboarding'
import { LoadingOverlay } from '@mantine/core'
import { GET_REDIRECT_DATA } from '../services/auth';
import { showNotification } from '@mantine/notifications';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/auth.context';
import { useQuery } from '../utility/util';

export default function RedirectPage() {
    const [loading, setLoading] = useState<boolean>(true);
    const navigate = useNavigate();
    const { search, pathname } = useLocation();
    const { signIn, onChangeRole } = useAuth();

    useEffect(() => {
        let queryObject: any = {};
        const params = new URLSearchParams(search);
        for (let [key, value] of params.entries()) {
            queryObject[key] = value;
        }
        setLoading(true);
        GET_REDIRECT_DATA({
            query: queryObject,
            pathname,
        })
            .then(({ signinUser, redirectType, activeRole }) => {
                navigate("/stripe/redirect")
                if (signinUser) signIn(signinUser, () => {
                    if (activeRole) onChangeRole(activeRole, true);
                    if (redirectType) {
                        if (redirectType === "whitelabel_onboarding") navigate("/onboarding");
                    } else {
                        navigate("/");
                    }
                });
            })
            .catch(err => {
                navigate("/not-found")
                showNotification({ message: err.message, color: "red" });
            })
            .finally(() => {
                setLoading(false);
            })
    }, [search.toString(), pathname.toString()]);

    return loading
        ? <LoadingOverlay />
        : null;
}